export const COLORS = {
  boursier: 'rgb(51, 122, 214)',
  standard: 'rgb(46, 139, 62)',
  other: 'rgb(128, 128, 128)',
  cream: '#fff8f3',
};

export const LINKS = {
  ios: 'https://apps.apple.com/app/id6755893262',
  android: 'https://play.google.com/store/apps/details?id=com.djammadev.shiniwari',
  manageCard: 'https://cards.servair.shinitech.com/',
  email: 'mailto:cheickm.sissoko@djammadev.com',
  phone: 'tel:+22377291138',
  whatsapp: 'https://wa.me/22377291138',
};

export const BRAND = {
  product: 'Shini Pay',
  tagline: 'Cartes cantine, dans l’app et dans Wallet',
  sampleCompany: 'Company Name',
};
